<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import VueApexCharts from 'vue-apexcharts'
import serviceContaPagar from '@/src/services/conta-pagar-receber'
import moment from 'moment'
moment.locale('pt-br')

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, apexchart: VueApexCharts },
  data() {
    return {
      currentMonth: "01",
      cashFlow: [],
      cashFlowField: [
        {
          key: 'data',
          label: 'Data',
          //class: 'size-col-20',
        },
        {
          key: 'recebimentos',
          label: 'Recebimentos',
          //class: 'size-col-20',
        },
        {
          key: 'pagamentos',
          label: 'Pagamentos',
          //class: 'size-col-20',
        },
        {
          key: 'saldo',
          label: 'Saldo',
          //class: 'size-col-20',
        },
      ],
      columnsExcel: [
        {
          label: 'Data',
          field: 'data',
        },
        {
          label: 'Recebimentos',
          field: 'recebimentos',
        },
        {
          label: 'Pagamentos',
          field: 'pagamentos',
        },
        {
          label: 'Saldo',
          field: 'saldo',
        },
      ],
      series: [],
      chartOptions: {
        colors: ['#4E9F3D', '#F05454'],
        chart: {
          width: 380,
          type: 'pie',
        },
        labels: ['Recebimentos', 'Pagamentos'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 400,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
      isLoading: false,
    }
  },
  computed: {
    rows() {
      return this.cashFlow.length
    },
  },
  watch: {},
  mounted() {
    this.currentMonth = moment().utcOffset("-03:00").format('MM');
    this.listando(moment().utcOffset("-03:00").format('MM'))
  },
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listando(month) {
      this.series = []
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      serviceContaPagar
        .findAllFlowAccount(token, month)
        .then((resposta) => {
          this.isLoading = false
          
          this.cashFlow = resposta.data.contas

          this.series.push(resposta.data.chart.recebimentos)
          this.series.push(resposta.data.chart.pagamentos)

          this.$refs.chart.refresh()
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Fluxo de caixa</div>
            <div class="subTitulo">Acompanhe seu fluxo de caixa.</div>
          </div>
          <div class="col-2">
            <div class="float-right">
              <button
                class="btn btn-primary"
                @click="$refs.btnexport.$el.click()"
              >
                Exportar Excel
                <vue-excel-xlsx
                  ref="btnexport"
                  style="display: none"
                  :data="cashFlow"
                  :columns="columnsExcel"
                  :filename="'fluxo_caixa'"
                  :sheetname="'fluxo_caixa'"
                >
                </vue-excel-xlsx>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card">
              <div class="card-body pb-0">
                <h5 class="card-title mb-0 header-title"
                  >Fluxo de caixa diário</h5
                >              
                <div v-if="series[0] > 1">
                  <apexchart
                    ref="chart"
                    type="pie"
                    width="450"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
                <div v-else><h5>Nenhuma movimentação financeira para exibir no Gráfico.</h5></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <b-tabs>
              <b-tab title="Janeiro" @click="listando('01')" :active="currentMonth === '01'" class="d-flex">
                <b-table
                  responsive
                  hover
                  :items="cashFlow"
                  :fields="cashFlowField"
                >
                  <template v-slot:cell(data)="row">
                    {{
                      formatDate(row.item.data) !== 'Invalid date'
                        ? formatDate(row.item.data)
                        : row.item.data
                    }}
                  </template>
                  <template v-slot:cell(recebimentos)="row">
                    <span style="color: #4e9f3d"
                      >+ {{ row.item.recebimentos }}</span
                    >
                  </template>
                  <template v-slot:cell(pagamentos)="row">
                    <span style="color: #f05454"
                      >- {{ row.item.pagamentos }}</span
                    >
                  </template>
                  <template v-slot:cell(saldo)="row">
                    <span :style="{ color: row.item.saldo.cor }">{{
                      row.item.saldo.valor
                    }}</span>
                  </template>
                </b-table>
              </b-tab>
              <b-tab title="Fevereiro" @click="listando('02')" :active="currentMonth === '02'" > </b-tab>
              <b-tab title="Março" @click="listando('03')" :active="currentMonth === '03'"> </b-tab>
              <b-tab title="Abril" @click="listando('04')" :active="currentMonth === '04'"> </b-tab>
              <b-tab title="Maio" @click="listando('05')" :active="currentMonth === '05'"> </b-tab>
              <b-tab title="Junho" @click="listando('06')" :active="currentMonth === '06'"> </b-tab>
              <b-tab title="Julho" @click="listando('07')" :active="currentMonth === '07'"> </b-tab>
              <b-tab title="Agosto" @click="listando('08')" :active="currentMonth === '08'"> </b-tab>
              <b-tab title="Setembro" @click="listando('09')" :active="currentMonth === '09'"> </b-tab>
              <b-tab title="Outubro" @click="listando('10')" :active="currentMonth === '10'"> </b-tab>
              <b-tab title="Novembro" @click="listando('11')" :active="currentMonth === '11'"> </b-tab>
              <b-tab title="Dezembro" @click="listando('12')" :active="currentMonth === '12'"> </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="false"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>